<li class="jobDetailListItem"><span [innerHTML]="text"></span></li>
